<template>

    <PublicWidgetsWrapper ref="wrapper">
        <div>
            <div style='text-align: center; font-family: "Montserrat", Sans-serif;
font-weight: 600;
line-height: 147.52%;' :style="(($vuetify.breakpoint.xs) ? 'font-size: 18px; padding-bottom: 10px;' : 'font-size: 37px; padding: 22px;')">
              Revolutionary New Software Helps Research,
              
              Identify, And Contact High Quality Local
              
              Business Prospects In Record Tme!
            </div>

            <div class="dashboard-box mb-6">
            <v-card
                class=""
                tile
            >
                <div class="lf-search-form dashboard">
                <div class="flex flex-row flex-wrap">
                    <div class="w-full lg:w-1/2 md:w-1/3">
                    <v-text-field
                        label="Enter a Keyword"
                        prepend-inner-icon="mdi-magnify"
                        v-model="search_keyword"
                        outlined
                        dense
                        hide-details
                        style="margin-top: 5px;"
                    ></v-text-field>
    
                    <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-2 ml-3 mr-3" />
                    </div>
    
                    <div class="w-full lg:w-1/2 md:w-1/3 -ml-6">
                    <div class="lf-search-location-box">
                        <v-combobox
                            label="Choose a City"
                            prepend-inner-icon="mdi-map-marker-outline"
                            append-icon=""
                            v-model="autocompleteLocationModel"
                            :items="locationFoundItems"
                            :search-input.sync="locationSearchText"
                            item-text="value"
                            item-value="id"
                            hide-no-data
                            return-object
                            outlined
                            dense
                            hide-details
                            @change="selectPlace()"
                            style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                        >
                        </v-combobox>
    
                        <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-4 ml-3 -mr-3" />
                    </div>
                    </div>
    
                    <div class="lf-search-form-search-type">
                    <v-radio-group
                      class="mt-3"
                      row
                      v-model="search_type"
                      >
                          <v-radio
                          label="Local"
                          :value="'local'"
                          on-icon="mdi-circle"
                          off-icon="mdi-circle-outline"
                          :ripple="false"
                          ></v-radio>
                          <v-tooltip bottom color="#434C5E">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-radio
                                  label="Multi-Snipe"
                                  :value="'in_depth'"
                                  on-icon="mdi-circle"
                                  off-icon="mdi-circle-outline"
                                  :ripple="false"

                                ></v-radio>
                              </span>
                            </template>
                            <span>
                              <strong>Multi-Snipe:</strong>
                              <br />
                              Multi-Snipe search will look up all the zip codes of the city you selected, and then does a search for every keyword in zip code combination.
                              <br /><br />
                              <strong>WARNING:</strong>
                              <br />
                              This can use a lot of Google API credits. If we find 10 zip codes -  we do 10 searches vs. 1. Thats 10 times the API requests.
                              <br />
                              Example: If a Local Search brings in 60 results thats 3 api queries to get the data, and then another 60 to pull the phone number for every listing. 
                              <br />
                              Thats 120 credits. Now if we used the Multi-Snipe feature - ad there were 10 zip codes - we would repeat the process 10 times. That means we'd use 10x the API requests.
                              <br /><br />
                              <strong>Cost breakdown:</strong>
                              <br />
                              - Get Keyword & Location: $0.032
                              <br />
                              - Main Search: $0.032
                              <br />
                              - Business Detail: $0.18 for 60 results
                            </span>
                          </v-tooltip>
                      </v-radio-group>
                    </div>
    
                    <div class="lf-search-form-submit-button" @click="addSearch()" style="right: 0px;">
                    <i v-if="savingSearch" class="fa fa-spin fa-spinner"></i>
                    <i v-else class="mdi mdi-magnify"></i>
                    </div>
                </div>
                </div>
            </v-card>
            </div>
  
            <div v-if="add_search_error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                <div v-html="add_search_error"></div>
            </div>
  
            <br clear="all" />
  
        </div>
  
    </PublicWidgetsWrapper>
  
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import $ from 'jquery'
  import moment from 'moment'
  import { GetSuggestions } from '@/utils/PlaceUtils'
  import PublicWidgetsWrapper from '@/views/panel/PublicWidgets/Wrapper.vue'
  
  export default {
    components: {
        PublicWidgetsWrapper
    },
    data () {
      return {
        search_keyword: null,
        add_search_error: null,
        
        autocompleteLocationModel: null,
        locationSearchText: null,
        locationEntries: [],
  
        search_type: 'local',
  
        savingSearch: false,
  
        search_location: null,
  
        searches_interval: null,
  
        new_searches: null,
        recent_searches: null,
        ip_count:0
      }
    },
    computed: {
      locationFoundItems () {
        return this.locationEntries
      }
    },
    methods: {
      
      async getSearches() {
        let url = `${process.env.VUE_APP_API_ENDPOINT}/dashboard-searches`;
  
        let response = await axios.get(url, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          }
        })
        this.new_searches = response.data.new_searches;
        this.recent_searches = response.data.recent_searches;
        this.ip_count = response.data.ip_count;
      },

      showLimitReached() {
        let noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
            <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -280px;">
                <h1 style="color: #FFFFFF; font-size: 30px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                    You have reached your limit. Upgrade your account to get unlimited searches.</p>

                <br />

                <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
            </div>
        </div>`;

        if (this.$vuetify.breakpoint.xs) {
            noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
              <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -129px;">
                      <h1 style="color: #FFFFFF; font-size: 24px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                      <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                          You have reached your limit. <br />Upgrade your account to get<br /> unlimited searches.</p>

                      <br />

                      <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
                  </div>
              </div>`;
        }

        parent.postMessage({
            event_id: 'postHtml',
            data: {
                newHtml: noAccessHtml
            }
        },"*");  //  `*` on any domain
      },
      getCookie: function(name) {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return null;
      },
      setCookie: function(name, value, days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); 
          document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
      },
      addSearch: async function() {
        if (this.new_searches.length + this.recent_searches.length >= 3) {
            // this.showLimitReached();
            // return;
        }
        if (this.ip_count >= 5) {
            this.showLimitReached();
            return;
        }
        this.add_search_error = null
  
        if (!this.search_keyword) {
          this.add_search_error = "Please enter keyword.";
          return;
        }
  
        if (!this.search_location) {
          this.add_search_error = "Please enter location.";
          return;
        }
        

        let searchCount = parseInt(this.getCookie('searchCount')) || 0;

        if (searchCount >= 5) {
            this.add_search_error = "Search limit reached (5 searches).";
            this.showLimitReached();
            return;
        }
        this.savingSearch = true;
  
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.search_keyword,
          search_location: this.search_location,
          search_type: this.search_type
        } , {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          },
        })
  
        searchCount++;
        this.setCookie('searchCount', searchCount, 7);

        window.top.location = process.env.VUE_APP_PUBLIC_WIDGETS_URL + '/my-searches';
  
        // this.savingSearch = false
        // this.search_keyword = null
        // this.search_location = null
        // this.autocompleteLocationModel = null
      },
      getAddressObject(address_components) {
  
        var ShouldBeComponent = {
          street_number: ["street_number"],
          zip: ["postal_code"],
          address: ["street_address", "route"],
          state: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
          ],
          city: [
            "locality",
            "colloquial_area",
            "political",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
          ],
          country: ["country"]
        };
  
        var address = {
          street_number: "",
          zip: "",
          address: "",
          state: "",
          city: "",
          country: ""
        };
        address_components.forEach(component => {
          for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
              if (shouldBe === "country") {
                address[shouldBe] = component.short_name;
              } else {
                address[shouldBe] = component.long_name;
              }
            }
          }
        });
        return address;
      },
      filterPlaces (item, queryText, itemText) {
        return true
      },
      selectPlace() {
        let that = this
  
        $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
          that.company_name = that.autocompleteLocationModel.value.split(",")[0];
  
          let address = that.getAddressObject(response.results[0].address_components);
          let search_location = {};
          search_location.street_number = address.street_number;
          search_location.address = address.address;
          search_location.city = address.city;
          search_location.state = address.state;
          search_location.zip = address.zip;
          search_location.country = address.country;
  
          search_location.lat = response.results[0].geometry.location.lat;
          search_location.lng = response.results[0].geometry.location.lng;
          search_location.place_id = response.results[0].place_id;
  
          that.search_location = search_location;
        });
      },
    },
    created() {
      this.getSearches();
    },
    watch: {
      locationSearchText (newVal) {
        var that = this;
  
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return
  
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            that.locationEntries = res;
          })
          .catch(function () {
            that.business = false;
            that.step = 1;
          })
      }
    }
  }
  </script>